import { useRouter } from 'next/router';
import { useContext } from 'react';
import { I18nContext } from 'src/stores/I18n';
import { SortType } from 'src/types/productSort';
import { mixpanel } from 'src/utils/mixpanel';
import styles from './index.module.scss';

type Props = {
  sort: SortType;
  setSort: React.Dispatch<React.SetStateAction<SortType>>;
  setPageIndex: React.Dispatch<React.SetStateAction<number>>;
};

export const ProductSortSelector: React.FC<Props> = ({ sort, setSort, setPageIndex }) => {
  const localeResources = useContext(I18nContext);
  const { asPath } = useRouter();

  return (
    <div className={styles.container}>
      <label htmlFor="product-sort-selector" className={styles.label}>
        {/* TODO: 翻訳 */}
        Sort Products By
      </label>
      <select
        id="product-sort-selector"
        className={styles.select}
        defaultValue={sort}
        onChange={(e) => {
          setPageIndex(1);
          mixpanel.onSortBy(e.target.value as SortType, asPath);
          setSort(e.target.value as SortType);
        }}
      >
        <option value="popular">{localeResources.products.sort.popular}</option>
        <option value="price_asc">{localeResources.products.sort.priceAsc}</option>
        <option value="price_desc">{localeResources.products.sort.priceDesc}</option>
      </select>
    </div>
  );
};
